module.exports = __webpack_public_path__ + "static/sscs-web-620ecc7dc6433a1be1057d747458784f.jpg";